import React from 'react';
import { Bar } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { analyticsChartTheme } from 'util/chartUtils';
import CardBox from '../../../../components/kea/CardBox';
import DashboardStub from '../../../../components/kea/DashboardStub';
import IntlMessages from 'util/IntlMessages';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

function AverageViews({ averageViews }) {
  const t = useLocalizedMessage();
  const chartOptions = {
    legend: {
      display: false,
    },
    tooltips: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      xAxes: [{
        stacked: false,
      }],
      yAxes: [{
        stacked: false,
        ticks: {
          beginAtZero: true,
        },
      }],
    },
  };

  function prepareData(data) {
    return {
      labels: [t('recs.dashboard.averageViews.axis')],
      datasets: [
        {
          label: t('ui.recs.dashboard.averageViews.didnTUseRecommendations'),
          backgroundColor: analyticsChartTheme.clickRateFill,
          data: [data.noRecs],
          categoryPercentage: 0.9,
          barPercentage: 0.9,
        }, {
          label: t('ui.recs.dashboard.averageViews.usedRecommendations'),
          backgroundColor: analyticsChartTheme.brand,
          data: [data.recs],
          categoryPercentage: 0.9,
          barPercentage: 0.9,
        },
      ],
    };
  }

  if (averageViews.error) {
    return (
      <CardBox header={t('recs.dashboard.averageViews.title')} styleName="recs-dashboard-card">
        <DashboardStub />
      </CardBox>
    );
  }
  const chartData = prepareData(averageViews);

  return (
    <CardBox header={t('recs.dashboard.averageViews.title')} styleName="recs-dashboard-card">
      <div className="row">
        <div className="col-6">
          <Bar data={chartData} options={chartOptions} height={240} />
        </div>
        <div className="col-6">
          <p>
            <IntlMessages id="ui.recs.dashboard.averageViews.visitorsWhoUsedRecommendationsViewOn" />
            {' '}
            {averageViews.rate}
            <IntlMessages id="ui.recs.dashboard.averageViews.moreProductsInAverage" />
          </p>
        </div>
      </div>

    </CardBox>
  );
}

AverageViews.propTypes = {
  averageViews: PropTypes.shape({
    recs: PropTypes.any,
    noRecs: PropTypes.any,
    rate: PropTypes.any,

    error: PropTypes.any,
  }).isRequired,
};

export default AverageViews;
